import moment from "moment";
export const convertIntoLowerCase = (param) => {
  if (typeof param === "string") return param?.toLowerCase();
  return "";
};
export function formatNumberWithCommas(number) {
  return Number(number)?.toLocaleString()||0;
}

export function formatText(input) {
  return input
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase
    .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter
}
export function formatPhone(phoneNumber) {
  const regex = /^\+(\d{2})(\d{3})(\d{3})(\d{4})$/;

  // Check if the number matches the pattern
  if (regex.test(phoneNumber)) {
    // Format the number with spaces
    return phoneNumber.replace(regex, "+$1 $2 $3 $4");
  } else {
    return "Invalid phone number format";
  }
}
export function formatNumber(value) {
  return Number(value).toLocaleString();
}
export function formatDateTime(dateTimeString, formatType) {
  const date = moment(dateTimeString, "YYYY-MM-DD HH:mm:ss");

  if (!date.isValid()) return "Invalid date";

  const formats = {
    time: "hh:mm A", // 12-hour format with AM/PM
    day: "DD/MM/YYYY", // Date format
  };

  return formats[formatType]
    ? date.format(formats[formatType])
    : "Invalid format type";
}

// Example Usage:
export function convertToAmPm(timeStr) {
  return moment(timeStr, "HH:mm:ss").format("h:mm A");
}

export function addMinutes(timeStr, minutes) {
  return moment(timeStr, "HH:mm:ss").add(minutes, "minutes").format("hh:mm A");
}

export const renderCommand = (command, value, data) => {
  return command ? command(value, data) : value;
};

export const subtractMonths = (months) => {
  return moment().subtract(months, "months").format("YYYY-MM-DD");
};

export const addMonths = (months) => {
  return moment().add(months, "months").format("YYYY-MM-DD");
};

export const amPmTimeFormat = (time) => {
  return moment(time, "HH:mm:ss").format("h:mm A");
};

export const formattedDate = (date) => moment(date).format("ddd, DD MMM `YY");
